import styles from './juicer_embed.module.sass'
import { useEffect, useState } from 'react'
import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import classNames from 'classnames'

function JuicerEmbed(props) {
	const fields = props.fields
	const embedId = fields.embed_id
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

	useEffect(() => {
		// Don't load Juicer in editor view
		if (document.body.classList.contains('wp-admin')) {
			return
		}

		// Handle window resize
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768)
		}

		window.addEventListener('resize', handleResize)

		// Load Juicer CSS if it hasn't been loaded yet
		if (!document.querySelector('link[href="https://www.juicer.io/embed.css"]')) {
			const link = document.createElement('link')
			link.rel = 'stylesheet'
			link.href = 'https://www.juicer.io/embed.css'
			link.defer = true
			document.head.appendChild(link)
		}

		// Load Juicer script if it hasn't been loaded yet
		if (!window.juicer) {
			const script = document.createElement('script')
			script.src = 'https://www.juicer.io/embed.js'
			script.async = true
			document.body.appendChild(script)
		} else {
			// If script is already loaded, just reinitialize
			window.juicer.init()
		}

		document.addEventListener('juicer:feedLoaded', () => {
			$('.juicer-feed').slick('resize');
		})

		return () => {
			window.removeEventListener('resize', handleResize)
		}
	}, [])

	return <BlockWrapper {...props} fullbleed={props.accordionContent ? false : true}>
		<ScrollAnimation styles={styles}>
			<div 
				className={classNames(styles.juicer_feed, 'juicer-feed')} 
				data-feed-id={embedId}
				data-truncate="200"
				data-columns={isMobile ? "1" : "3"}
			></div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default JuicerEmbed